import { TApiData } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const upsertServices = (payload: TApiData): Promise<any> => {
  return API.post(`/api/accommodation/reservation/calculate/addedServices`, payload).then(
    res => res?.data,
  );
};
